import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Hourglass = (props) => (
  <SvgIcon width="45.2" height="66.4" viewBox="0 0 45.2 66.4" {...props}>
    <g id="noun_hourglass_160360" transform="translate(-27.4 -16.8)">
      <g id="Groupe_6033">
        <path
          id="Tracé_3704"
          d="M33.2 21.6v3c.2 10.4 2.5 18 6.9 22.5a12.9 12.9 0 0 0 3.7 2.8 14 14 0 0 0 5.2 1.5h2a14.893 14.893 0 0 0 5.3-1.5c4.6-2.5 10.2-8.9 10.6-25.3v-3H33.2zM51 48.5h-1.8a10.411 10.411 0 0 1-6.8-3.4c-3.8-3.9-5.8-10.9-6-20.4H64c-.6 21.2-10 23.6-13 23.8"
        />
        <path
          id="Tracé_3705"
          d="M66.8 75.3c-.3-16.4-5.9-22.8-10.5-25.3a12.642 12.642 0 0 0-5.3-1.5h-2a14 14 0 0 0-5.2 1.5c-4.6 2.5-10.2 8.9-10.6 25.3v3h33.7v-1.5c0-.5-.1-1-.1-1.5M37 66.8a22.136 22.136 0 0 1 .7-3c2.8-10.6 9-12.1 11.3-12.3h2.1c2.1.2 7.5 1.4 10.6 9.8a46 46 0 0 1 1.4 5.1 54.412 54.412 0 0 1 .9 8.9H36.2a52.294 52.294 0 0 1 .8-8.5"
        />
        <path
          id="Tracé_3706"
          d="M27.4 83.2h45.2v-7.9H27.4zm42.2-3H30.4v-1.9h39.2z"
        />
        <path
          id="Tracé_3707"
          d="M27.4 24.7h45.2v-7.9H27.4zm42.2-3.1H30.4v-1.9h39.2z"
        />
        <path
          id="Tracé_3708"
          d="M65.3 64.5L63 66.4c-4.3-5.3-9.5-3.3-14.9-1.2a22.6 22.6 0 0 1-8.2 2.1 9.291 9.291 0 0 1-2.9-.5 6.515 6.515 0 0 1-2.3-1.5l2.1-2.2a5.5 5.5 0 0 0 .9.7c2.2 1.2 5.1.3 9.3-1.4 4.5-1.7 9.8-3.8 14.6-1.1a13.475 13.475 0 0 1 3.7 3.2"
        />
      </g>
    </g>
  </SvgIcon>
);

export default Hourglass;
